import { ProductDetailViewEvent } from '@/usecases/event-bus-for-third-party/events/product-detail'

import { Fku, Sku } from './model/item'

export interface ProductDetailViewEventRootContext {
  readonly name: string
  readonly brandEnglishName: string
  readonly categoryPathnames: string[]
}

export function createProductDetailViewEvent(
  root: ProductDetailViewEventRootContext,
  fkuList: Fku[]
): ProductDetailViewEvent {
  return {
    root: {
      name: root.name,
      brand: root.brandEnglishName,
      // string[]型をとっているがproductclass.categoriesの長さは0か1なので複数個になることはないことに注意
      category: root.categoryPathnames,
    },
    fku: fkuList.map(fku => ({
      id: fku.id,
      color: fku.colorLabel,
      price: priceRange(fku.skuList),
      sku: fku.skuList.map(sku => ({
        id: sku.id,
        short_id: sku.shortId,
        price: selectedPrice(sku),
        sku_number: sku.skuNumber,
        // アパレル商品詳細ではカラー/サイズ選択肢が初期表示されているため、全SKUを初期表示扱いにする。
        isInitialDisplayed: true,
      })),
    })),
  }
}

function priceRange(skuList: Sku[]): { min: number, max: number } {
  const prices = skuList.map(selectedPrice)

  return {
    min: Math.min(...prices),
    max: Math.max(...prices),
  }
}

function selectedPrice(sku: Sku): number {
  return sku.price.prices.selected.price
}
